// extracted by mini-css-extract-plugin
export var orderDetails = "_pn-2";
export var orderImage = "_pn-1";
export var orderMeta = "_pn-3";
export var orderSummary = "_pn-0";
export var rightArrow = "_pn-4";